import React from "react";
import config from "appConfig";
import { Row, Col, Tag } from "antd";
import { Link } from "react-router-dom";
import { getImageLink, getImageUrl } from "../../../../../services/asset";
import { GarbageIcon } from "./GarbageIcon";
import { stringifyURI } from "../../../../../services";

import NotificationSelector from "./NotificationSelector";
import styles from "./savedSearchItem.scss";
import {
  PageRoute,
  QueryParam
} from "../../../../../models";
import {
  mapCategoryToHr,
  mapModuleToHr
} from "../../../../../routes/LanguageMapper";

const defaultSettings = {
  responsiveProps: {
    category: { xs: 24, sm: 4, md: 3 },
    name: { xs: 24, sm: 20, md: 12 },
    notification: { sm: 24, md: 6 },
    delete: { sm: 24, md: 3 }
  }
};

// Link of a saved search: the API returns the seo path of its criteria
// ("/auto-moto/osobni-automobili/bmw/x5/pretraga"), the query holds the criteria.
const buildSearchUrl = item => {
  // Include text field in criteria if it exists at the top level
  const criteriaWithText = item.text
    ? { ...item.criteria, text: item.text }
    : item.criteria;

  const query = stringifyURI(criteriaWithText, QueryParam.searchQuery);

  if (item.seoPath) {
    return `${item.seoPath}${query}`;
  }

  return `${item.module ? `/${mapModuleToHr(item.module)}` : ""
    }${item.category ? `/${mapCategoryToHr(item.category, item.module)}` : ""
    }${PageRoute.search}${query}`;
};

const SavedSearchItem = props => {
  const { item, settings, onDelete, onNotificationChange } = props;
  return (
    <Row className={styles.listItem}>
      <Col
        {...settings.responsiveProps.category}
        className={`child-center ${styles.itemImage}`}
      >
        <Link title={item.Name} to={buildSearchUrl(item)}>
          {
            (item.category && item.module) ?
              <img
                src={`${getImageUrl(item.category)}.png`}
                onError={(e) => { e.target.src = `${getImageUrl(item.module)}.png` }}
              /> : <img src={getImageUrl(config.imagePlaceholder)} />
          }
        </Link>
      </Col>
      <Col {...settings.responsiveProps.name} className={styles.itemTitle}>
        <Link title={item.Name} to={buildSearchUrl(item)}>
          <div className={styles.itemDate}>{item.formattedCreatedTime}</div>
          <div className={styles.itemName}>
            {item.name}
          </div>
        </Link>
        <div>
          {item.tags.map((tag) => <Tag key={tag} className={styles.itemTag}>{tag}</Tag>)}
        </div>
      </Col>

      <Col {...settings.responsiveProps.notification}>
        <NotificationSelector
          hasIcon
          value={item.notifyFrequency}
          onChange={value => onNotificationChange(item, value)}
          className={styles.notification}
        />
      </Col>
      <Col
        {...settings.responsiveProps.delete}
        className={styles.itemDeleteCol}
      >
        <span
          role="button"
          tabIndex={0}
          className={styles.deleteIcon}
          onClick={() => onDelete(item.id)}
        >
          <GarbageIcon />
        </span>
        <span className={styles.deleteText} onClick={() => onDelete(item.id)}>
          {"Obriši"}
        </span>
      </Col>
    </Row>
  );
};

SavedSearchItem.defaultProps = {
  settings: defaultSettings
};

export default SavedSearchItem;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchWeb/SavedSearchItem/index.tsx